import { Pipe, PipeTransform } from '@angular/core';
import { JobType } from './job-types/job-type.model';

@Pipe({
  name: 'jobName',
})
export class JobNamePipe implements PipeTransform {
  transform(value: number | null, jobs: JobType[]): string {
    if (value === null) {
      return 'N/D';
    }
    const jobType = jobs.find((jt) => jt.id === value);
    return jobType ? jobType.name : 'N/D';
  }
}
